import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GridColumn } from '../../column/column.component';
import { GridRow } from '../../row/row.component';
import { GridViewBase } from '../grid-view-base.component';
import { CdkDrag, CdkDropList, CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'lepi-grid-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  standalone: true,
  imports: [GridRow, GridColumn, CommonModule, CdkDropList, CdkDrag],
})
export class GridTable extends GridViewBase {
  onDrop(event: CdkDragDrop<unknown>) {
    const opts = this.options();
    if (opts?.view === 'table') {
      const dragDrop = opts.dragDrop;
      if (dragDrop?.enable && dragDrop.handler) {
        if (event.previousIndex !== event.currentIndex) {
          dragDrop.handler(event);
        }
      }
    }
  }

  get dragDropEnabled(): boolean {
    const opts = this.options();
    if (opts?.view === 'table') {
      return !!opts.dragDrop?.enable;
    }
    return false;
  }
}
